import React from 'react';

const StudentLogin = () => (
  <div style={{ padding: 32 }}>
    <h2>Student Login</h2>
    <p>This is the Student Login page. Add your student login form here.</p>
  </div>
);

export default StudentLogin;
